import React from "react";
import { WorkspaceMember } from "@common/types/workspace";
import { AvatarGroup } from "@design-system/Avatar/AvatarGroup";
import { UserAvatar } from "@components/avatar/UserAvatar";
import { AvatarTooltip } from "@components/avatar/AvatarTooltip";
import styles from "./ConsolidationMembersCell.module.scss";

interface ConsolidationMembersCellProps {
    members: WorkspaceMember[];
}

const memberLabel = (member: WorkspaceMember): string =>
    member.user.name ?? member.user.email;

export const ConsolidationMembersCell: React.FC<
    ConsolidationMembersCellProps
> = ({ members }) => {
    if (members.length === 0) {
        return <span className={styles.empty}>-</span>;
    }

    return (
        <AvatarGroup
            items={members}
            getKey={(member) => member.user.id}
            getLabel={memberLabel}
            renderAvatar={(member) => (
                <AvatarTooltip content={memberLabel(member)}>
                    <UserAvatar user={member.user} />
                </AvatarTooltip>
            )}
            max={3}
            size="xs"
        />
    );
};
